module.exports = __webpack_public_path__ + "static/media/1015886.f48398a8.png";